// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAhYDE-mQWuDvVRMTwlw1Im_vtTOdw35x8",
  authDomain: "monitor-4c028.firebaseapp.com",
  projectId: "monitor-4c028",
  storageBucket: "monitor-4c028.appspot.com",
  messagingSenderId: "675007819644",
  appId: "1:675007819644:web:f40c35e2bbcee31e297ef9"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Erreur persistence auth:", error);
});

export { db, auth };
